module.exports = __webpack_public_path__ + "static/img/Corey-Horsburgh.fb90555.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Corey-Horsburgh.jpg
// module id = O2AS
// module chunks = 0